export const colorPalette = {
  primary: '#004BA5',
  white: '#ffffff',
  disabledColor: '#7A7A7A',
  background: '#F4F7FE',
  cardColor: '#EFEFEF',
  black: '#000',
  error: 'red'
}